<template>
  <b-container fluid>
    <page-title><h2><router-link :to="{ name: 'FileTypeList' }" class="nav-link">Typy plików</router-link>/Nowy typ pliku</h2></page-title>

    <div class="col page-element">
      <alert-loading v-if="loading"></alert-loading>
      <div v-if="error" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ error }}</div>

      <FileTypeForm v-if="!loading" :handle-submit="create" :values="item" :errors="violations"></FileTypeForm>
    </div>
  </b-container>
</template>

<script>
  import FileTypeForm from './Form.vue';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions, mapGetters } = createNamespacedHelpers('filetype/create');

  export default {
    components: {
      FileTypeForm
    },
    created(){
      this.$store.dispatch('filetype/create/reset');
    },
    data: function() {
      return {
        item: {}
      }
    },
    computed: mapGetters([
      'error',
      'loading',
      'created',
      'violations'
    ]),
    methods: {
      create: function(item) {
        this.$store.dispatch('filetype/create/create', item);
      }
    },
    watch: {
      created: function (created) {
        if (created) {
          this.$router.push({ name: 'FileTypeUpdate', params: { id: created['id']} });
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Create.vue?61260211